<template>
    <app-admin-layout>
        <Head>
            <title>Mail Debug</title>
        </Head>

        <div class="dashboard mail-debug">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <card>
                            <card-header>
                                <card-overline>
                                    E-Mail Konfiguration
                                </card-overline>
                            </card-header>
                            <card-content>
                                <table class="table table--stripped table--card">
                                    <tbody>
                                    <tr>
                                        <td><strong>Domain</strong></td>
                                        <td>{{ mailConfig.domain }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>SMTP Host</strong></td>
                                        <td>{{ mailConfig.host }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>SMTP Port</strong></td>
                                        <td>{{ mailConfig.port }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Verschlüsselung</strong></td>
                                        <td>{{ mailConfig.encryption || 'keine' }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Absender Adresse</strong></td>
                                        <td>{{ mailConfig.fromAddress }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Absender Name</strong></td>
                                        <td>{{ mailConfig.fromName }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </card-content>
                        </card>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col">
                        <card>
                            <card-header>
                                <card-overline>
                                    Test E-Mail senden
                                </card-overline>
                            </card-header>
                            <card-content>

                                <div v-if="$page.props.flash?.success" class="text-success">
                                    <strong>{{ $page.props.flash.success }}</strong>
                                </div>
                                <div v-if="$page.props.flash?.error" class="text-error">
                                    <strong>{{ $page.props.flash.error }}</strong>
                                </div>

                                <p class="mb-3">
                                    Klicken Sie auf die Schaltfläche, um eine Test-E-Mail an Ihre Admin-E-Mail-Adresse zu senden.
                                </p>

                                <form @submit.prevent="sendTestEmail">
                                    <form-input
                                        id="email"
                                        type="email"
                                        label="Empfänger E-Mail"
                                        v-model="form.email"
                                        :error="form.errors.email"
                                        required
                                    />
                                    <form-button type="submit" :loading="form.processing" class="mt-3">
                                        Debug E-Mail senden
                                    </form-button>
                                </form>
                            </card-content>
                        </card>
                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormInput from '@partfactory/Shared/Form/FormInput';
import { useForm } from '@inertiajs/vue3';

export default {
    name: 'MailDebug',
    components: {
        FormInput,
        FormButton,
        CardContent,
        CardOverline,
        CardHeader,
        Card,
        AppAdminLayout,
    },
    props: {
        mailConfig: Object,
    },
    setup() {
        const form = useForm({
            email: '',
        });

        return { form };
    },
    methods: {
        sendTestEmail() {
            this.form.post(this.$$route('mail-debug.send'));
        },
    },
};
</script>
